import React from 'react'
import { Divider, useTheme } from '@chakra-ui/react'

function UnderLine() {
  const theme = useTheme()
  return (
    <Divider
      width="70px"
      border="5px"
      borderColor={theme?.colors?.secondary?.base}
      borderStyle="solid"
      borderRadius="15px"
    />
  )
}

export default UnderLine
